// extracted by mini-css-extract-plugin
module.exports = {"solar-60w-D":"D_solar-60w-D__xIJiX"};